(function($) {

	$.fn.tableRowHighlighter = function(options) {
        // build main options before element iteration
        var opts = $.extend(true, {}, $.fn.tableRowHighlighter.defaults, options);

		return this.each(function() {
			var $this = $(this);
            // build element specific options
            var eOpts = $.metadata ? $.extend(true, {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend(true, eOpts, $this.dataset()) : eOpts;

            var notSelector = ':not('+eOpts.selector+')';
            
            $this.find(eOpts.selector).prev().addBack().hover(function(){
                var $tr = $(this);
                if($tr.is(eOpts.selector)) {
                    var $master = $tr.prevUntil(notSelector).andSelf().prev();
                    var $details = $master.nextUntil(notSelector);
                    $master.addClass('hover');
                    $details.addClass('hover');
                }
                else {
                    $tr.nextUntil(notSelector).addClass('hover');
                }
            }, function(){
                var $tr = $(this);
                if($tr.is(eOpts.selector)) {
                    var $master = $tr.prevUntil(notSelector).andSelf().prev();
                    var $details = $master.nextUntil(notSelector);
                    $master.removeClass('hover');
                    $details.removeClass('hover');
                }
                else {
                }
                $tr.nextUntil(notSelector).removeClass('hover');
            });
        });
	};
    //
    // plugin defaults
    //
    $.fn.tableRowHighlighter.defaults = {
        'selector': 'tr.description-row'
    };

})(jQuery);